import React from 'react';
import { Switch, SwitchProps } from '@mui/material';

/**
 * Стилизованный Switch компонент с корпоративным фиолетовым цветом.
 */
export const TmSwitch: React.FC<SwitchProps> = (props) => {
    const { sx, color, ...otherProps } = props;
    
    return (
        <Switch
            {...otherProps}
            color={undefined} // Убираем color prop, чтобы не использовался primary цвет
            sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#9588e8 !important',
                    '&:hover': {
                        backgroundColor: 'rgba(149, 136, 232, 0.08)',
                    },
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#9588e8 !important',
                },
                ...sx, // Позволяет переопределить стили при необходимости
            }}
        />
    );
};

